import React from 'react';
import cx from 'classnames';

import styles from './styles.css';

export const Description = ({ children, ...rest }: any) => (
  <p className={styles.description} {...rest}>
    {children}
  </p>
);
